const e = {
  name: "IceCream",
  dimensions: { width: 18, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 18 40" style="enable-background:new 0 0 18 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6,31H3c-1.7,0-3-1.3-3-3V3c0-1.7,1.3-3,3-3h12c1.7,0,3,1.3,3,3v25c0,1.7-1.3,3-3,3h-3v9H6V31z M2,3v2.6
			L5.6,2H3C2.4,2,2,2.4,2,3z M2,8.4v8.2L15.9,2.6C15.8,2.3,15.4,2,15,2H8.4L2,8.4z M2,19.4v7.2l14-14V5.4L2,19.4z M2.5,28.9
			C2.7,29,2.8,29,3,29h6.6l6.4-6.4v-7.2L2.5,28.9z M15,29c0.6,0,1-0.4,1-1v-2.6L12.4,29H15z M8,31v7h2v-7H8z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as IceCream
};
